import React from 'react';

import { Button, Text } from 'theme-ui';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-light-svg-icons';

import withTheme from '../../../withTheme';

export type PropsT = {
  handleClick: () => void;
  label?: string;
};

const ToggleButton = ({ handleClick, label }: PropsT) => {
  return (
    <Button
      variant="unstyled"
      onClick={handleClick}
      aria-label="Toggle"
      sx={{
        display: 'flex',
        alignItems: 'center',

        py: 2,
        px: 0,
      }}
    >
      {label && <Text sx={{ fontWeight: 'bold', mr: 2 }}>{label}</Text>}
      <FontAwesomeIcon icon={faBars} stroke="1px" size="lg" />
    </Button>
  );
};

export default withTheme(ToggleButton);
